module.exports = __webpack_public_path__ + "static/img/7.0b30f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/7.png
// module id = PNKn
// module chunks = 0